import { motion } from "framer-motion";
import { Globe2, Radio, Users, ArrowUpRight } from "lucide-react";
import { scrollToId } from "./Nav";

const PILLARS = [
  {
    icon: Globe2,
    n: "A",
    title: "Global Culture Discovery",
    body: "Search by continent and experience content and creators shaped by real communities around the world. Not trends. Not algorithms — real places, real people, real culture.",
    testid: "pitch-card-launch",
  },
  {
    icon: Radio,
    n: "B",
    title: "Streaming Without Borders",
    body: "Watch live moments and original programming from across the globe, no matter where you live. If it's happening, you can be part of it — 193 countries, every major screen.",
    testid: "pitch-card-distribution",
  },
  {
    icon: Users,
    n: "C",
    title: "Community Powered Viewing",
    body: "Fans aren't just viewers here. They're supporters, participants, and amplifiers of the culture they love. This is where audiences become ecosystems.",
    testid: "pitch-card-studio",
  },
];

export default function Pitch() {
  return (
    <section id="launchpad" className="relative py-24 lg:py-32 px-4 sm:px-8 lg:px-16" data-testid="pitch-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mb-16"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-signal">
            The Movement
          </span>
          <h2 className="mt-3 font-head font-extrabold tracking-tight text-base md:text-lg text-slate-300 max-w-xl leading-relaxed">
            Stories don't need permission anymore. They need platforms that understand where they come from.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -8 }}
              className="group relative glass-panel p-8 lg:p-10 overflow-hidden"
              data-testid={p.testid}
            >
              <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-signal/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="flex items-start justify-between">
                <p.icon size={28} className="text-signal" strokeWidth={1.5} />
                <span className="font-display font-extrabold text-5xl text-outline leading-none select-none">
                  {p.n}
                </span>
              </div>
              <h3 className="mt-8 font-head font-bold tracking-tight text-xl sm:text-2xl text-white">
                {p.title}
              </h3>
              <p className="mt-4 text-sm text-slate-400 leading-relaxed">{p.body}</p>
              <button
                data-testid={`${p.testid}-cta`}
                onClick={() => scrollToId("#contact")}
                className="mt-8 flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] uppercase text-slate-500 group-hover:text-signal transition-colors duration-300"
              >
                Start the conversation
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
